import { render, staticRenderFns } from "./PersonalArea.vue?vue&type=template&id=143383c3&scoped=true"
import script from "./PersonalArea.vue?vue&type=script&lang=js"
export * from "./PersonalArea.vue?vue&type=script&lang=js"
import style0 from "./PersonalArea.vue?vue&type=style&index=0&id=143383c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143383c3",
  null
  
)

export default component.exports